import { render, staticRenderFns } from "./PaymentBraintreeInputs.vue?vue&type=template&id=76b4756a&"
import script from "./PaymentBraintreeInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentBraintreeInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports